module.exports = __webpack_public_path__ + "static/media/ivn_security_icon.d9aa0764.svg";